import { UseQueryOptions } from '@tanstack/react-query'
import { differenceInMilliseconds } from 'date-fns'

import { QueryKey } from './queryKey'

export const QUERY_REFETCH_INTERVAL = 60_000

export const getQueryRefetchOptions = <T extends unknown>(
  refetchInterval = QUERY_REFETCH_INTERVAL,
): Partial<UseQueryOptions<T>> => ({
  refetchInterval,
  refetchOnWindowFocus: query => {
    return (
      differenceInMilliseconds(Date.now(), query.state.dataUpdatedAt) > refetchInterval
    )
  },
  refetchOnMount: true,
})

export const getRealTimeQueryKeys = (): QueryKey[] => [
  QueryKey.GetAgentAttendanceDetails,
  QueryKey.GetAgentAttendanceIntervals,
  QueryKey.GetQueuesHealthDetails,
  QueryKey.GetTicketsVolume,
]
